var _style, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifierMobile1 = function SvgMagnifierMobile1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".magnifier_mobile1_svg__st0{fill:none;stroke:#000;stroke-width:1.3;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("g", {
    id: "magnifier_mobile1_svg__Layer_1"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "magnifier_mobile1_svg__st0",
    cx: 23.3,
    cy: 23,
    r: 6.5
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 1.3,
      strokeMiterlimit: 10
    },
    d: "m28.1 28.1 4.2 4.3",
    id: "magnifier_mobile1_svg__Layer_5"
  })));
};
export default SvgMagnifierMobile1;